'use strict'

import Vue from 'vue'
import axios from 'axios'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  baseURL: process.env.VUE_APP_API_URL,
  // timeout: 60 * 1000, // Timeout
  credentials: true, // Check cross-site Access-Control
  withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    const crypto = Vue.CryptoJS
    const pass = process.env.VUE_APP_CRYPTO_PASS
    if (config.url.includes('/token/refresh')) {
      let token
      if (Object.keys(localStorage).includes('refreshJWTWeb')) {
        token = localStorage.getItem('refreshJWTWeb')
      } else if (Object.keys(sessionStorage).includes('refreshJWTWeb')) {
        token = sessionStorage.getItem('refreshJWTWeb')
      }
      token = crypto.AES.decrypt(
        token || ' ',
        pass,
      ).toString(crypto.enc.Utf8)
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } else {
      let token
      if (Object.keys(localStorage).includes('tokenJWTWeb')) {
        token = localStorage.getItem('tokenJWTWeb')
      } else if (Object.keys(sessionStorage).includes('tokenJWTWeb')) {
        token = sessionStorage.getItem('tokenJWTWeb')
      }
      token = crypto.AES.decrypt(
        token || ' ',
        pass,
      ).toString(crypto.enc.Utf8)
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  },
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error)
  },
)

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios
      },
    },
    $axios: {
      get () {
        return _axios
      },
    },
  })
}

Vue.use(Plugin)

export default Plugin
